import React, { useContext } from 'react'
import debounce from 'lodash/debounce'
import { CacheStoreContext } from 'Components/cache-store'
const useCache = () => {
  const { cache } = useContext(CacheStoreContext)
  if (!cache) {
    return {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setStorage: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      getStorage: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      clearStorage: () => {},
    }
  }
  const _setStorage = debounce(
    (key, value, setSaving: ((b: boolean) => void) | undefined) => {
      if (setSaving) {
        setSaving(true)
      }
      console.log('storage value to be set', value)
      // window.localStorage.setItem(key, JSON.stringify(value))
      cache.set(key, value)
      if (setSaving) {
        setSaving(false)
      }
    },
    1000
  )

  const setStorage = (
    key: string,
    value: any,
    setSaving: ((b: boolean) => void) | undefined
  ) => {
    if (setSaving) {
      setSaving(true)
    }
    _setStorage(key, value, setSaving)
  }

  const getStorage = (key: string): any => {
    // return JSON.parse(window.localStorage.getItem(key) || 'null')
    return cache.get(key) // "value"
  }

  const clearStorage = (key: string) => {
    cache.del(key)
  }

  return {
    setStorage,
    getStorage,
    clearStorage,
  }
}

export default useCache
